import { type Level } from '@/lib/types';
import { useContext } from 'react';
import RubricsPortfolioContext from '@/lib/contexts/RubricsPortfolioContext';
import RestrictedToPortfolioMode from '@/components/RestrictedToPortfolioMode';
import PortfolioMode from '@/lib/constants/PortfolioMode.enum';
import AttachmentSectionTitle from '../AttachmentSectionTitle';
import LevelProgressNote from './LevelProgressNote';
import AddLevelProgressNote from './AddLevelProgressNote';
import NoSectionContentMessage from '../NoSectionContentMessage';
import CommentsWrapper from '../CommentsWrapper';
import { FormattedMessage } from 'react-intl';
import AttachmentSection from '../AttachmentSection';
import sortByCreatedAt from '@/lib/utils/sorting/sortByCreatedAt';

type LevelProgressNotesProps = {
  level: Level;
};

const LevelProgressNotes = ({ level }: LevelProgressNotesProps) => {
  const [portfolio] = useContext(RubricsPortfolioContext);
  const levelProgressNotes = Object.values(
    portfolio.levelProgressNotes?.[level.id] ?? {},
  );

  return (
    <AttachmentSection>
      <AttachmentSectionTitle>
        <FormattedMessage id="portfolio.level.attachments.level_progress_notes.section_title" />
      </AttachmentSectionTitle>
      {levelProgressNotes.length === 0 ? (
        <NoSectionContentMessage>
          <FormattedMessage id="portfolio.level.attachments.level_progress_notes.no_notes_message" />
        </NoSectionContentMessage>
      ) : (
        <CommentsWrapper>
          {levelProgressNotes.sort(sortByCreatedAt).map(levelProgressNote => (
            <LevelProgressNote
              levelProgressNote={levelProgressNote}
              key={levelProgressNote.id}
            />
          ))}
        </CommentsWrapper>
      )}
      <RestrictedToPortfolioMode mode={PortfolioMode.STUDENT}>
        <AddLevelProgressNote level={level} />
      </RestrictedToPortfolioMode>
    </AttachmentSection>
  );
};

export default LevelProgressNotes;
